// Blog filter
(function () {
  var filterList    = document.querySelector('.main-blog__filter-list');
  var filterItems   = Array.from(document.querySelectorAll('.main-blog__filter__item'));
  var filterBtn     = document.querySelector('.main-blog__filter__button');
  var filterCurrent = document.querySelector('.main-blog__filter-list__current');
  var pathname      = window.location.pathname;

  if (filterList) {
    filterList.addEventListener('click', function () {
      filterList.classList.toggle('active');
    });
  }

  filterItems.forEach(function (item) {
    item.addEventListener('click', function () {
      filterItems.forEach(function (i) { i.classList.remove('active'); });
      item.classList.add('active');
      var span = filterCurrent && filterCurrent.querySelector('span');
      if (span) span.textContent = item.textContent;
      if (filterBtn) filterBtn.setAttribute('href', item.dataset.href);
    });
  });

  if (pathname) {
    filterItems.forEach(function (item) {
      if (pathname.includes(item.dataset.tagHandle)) {
        var span = filterCurrent && filterCurrent.querySelector('span');
        if (span) span.textContent = item.textContent;
      }
    });
  }
})();

// Blog sort
(function () {
  var sortBars = Array.from(document.querySelectorAll('[data-sort-bar]'));
  if (!sortBars.length) return;

  function sort(param) {
    var items = Array.from(document.querySelectorAll('[data-sort-item]'));
    var clean = function (str) { return str ? str.replace(/th,|st,|nd,|rd,/g, ',') : null; };

    items.slice().sort(function (a, b) {
      var aEl = a.querySelector('.heading, .pd-card-article__title');
      var bEl = b.querySelector('.heading, .pd-card-article__title');
      var aTitle = aEl && aEl.innerHTML;
      var bTitle = bEl && bEl.innerHTML;
      var aDate  = clean(a.getAttribute('data-publish-as'));
      var bDate  = clean(b.getAttribute('data-publish-as'));

      switch (param) {
        case 'title-ascending':    return aTitle && bTitle ? aTitle.localeCompare(bTitle)  : 0;
        case 'title-descending':   return aTitle && bTitle ? -aTitle.localeCompare(bTitle) : 0;
        case 'created-ascending':  return aDate  && bDate  ? new Date(aDate) - new Date(bDate) : 0;
        case 'created-descending': return aDate  && bDate  ? new Date(bDate) - new Date(aDate) : 0;
        default: return 0;
      }
    }).forEach(function (item, idx) {
      item.style.order = idx;
    });
  }

  sortBars.forEach(function (bar) {
    var select = bar.querySelector('[data-sort-select]');
    var toggle = bar.querySelector('[data-sort-toggle]');
    sort('created-descending');
    if (!select) return;

    function hide() {
      select.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    select.addEventListener('change', function () {
      sort(select.value);
      hide();
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (select.hidden) {
          select.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          if (typeof select.showPicker === 'function') {
            try { select.showPicker(); } catch (e) { select.focus(); }
          } else {
            select.focus();
          }
        } else {
          hide();
        }
      });

      document.addEventListener('click', function (e) {
        if (!select.hidden && !bar.contains(e.target)) hide();
      });
    }
  });
})();

// Blog topic drawer (topics are server-side tagged links, one at a time)
(function () {
  var bar = document.querySelector('[data-topic-bar]');
  if (!bar) return;

  var toggle = bar.querySelector('[data-topic-toggle]');
  var drawer = bar.querySelector('[data-topic-drawer]');
  if (!toggle || !drawer) return;

  var closers = Array.from(drawer.querySelectorAll('[data-topic-close]'));

  function open() {
    drawer.hidden = false;
    void drawer.offsetWidth; // reflow so the slide-in transition runs from the closed state
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('main-blog__topic-drawer-open');
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('main-blog__topic-drawer-open');
    var onEnd = function (e) {
      if (e.target !== drawer.querySelector('.main-blog__topic-drawer__dialog')) return;
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', onEnd);
    };
    drawer.addEventListener('transitionend', onEnd);
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) { close(); } else { open(); }
  });

  closers.forEach(function (el) { el.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
